import {Injectable} from "@angular/core";
import {BugsnagLoggingService} from "../logging/bugsnag-logging.service";
import {EventBus} from "../../event/EventBus";
import {DebugCommand, DebugEvent} from "../../event/DebugEvent";
import {IRecognizedSequence} from "../recognition/recognizer.service";
import {RUNTIMETEST_STATUS, RuntimeTestEvent} from "../../event/RuntimeTestEvent";
import {ClientConfiguration} from "../configuration/client.config";
import {StudentConfiguration} from "../assignment/student.configuration";
import {MessageEventData} from "../../event/ActivityEvent";
import {BookSessionType, Scilearn} from "../../constants";
import {Timer, TimerOptions} from "../configuration/timer.service";
import {ModalConfig} from "../notification/modal.config";
import {TAI_STATUS, TaiEvent} from "../../event/TaiEvent";
import {UserModelChangedEvent} from "../../event/UserModelEvents";
import {IUserModelDelta} from "../usermodel/usermodel.objects";

@Injectable()
export class DebugService {

    constructor(private log: BugsnagLoggingService, private eventBus: EventBus, private config: ClientConfiguration,
                private studentConfig: StudentConfiguration, private modalConfig: ModalConfig) {
    }

    static isDebugKey(value: string): boolean {
        return ["a", "c", "d", "i", "r", "s", "t", "p", "l", "g"].indexOf(value.toLowerCase()) > -1 ||
            (parseInt(value, 10) >= 0 && parseInt(value, 10) <= 9);

    }

    static isDebugSequence(recognized: IRecognizedSequence): boolean {
        return recognized.debugCommand !== undefined;
    }

    handleKeyboardEvent(event: KeyboardEvent): void {

        switch (event.key.toLowerCase()) {
            case "0":
                if (this.config.allowBrowserVersion) {
                    this.modalConfig.openModal(new MessageEventData({ timer: new Timer(<TimerOptions>{
                                totalTime: 30 * 60 * 1000,
                                type: Scilearn._TRAINING_TIMER
                            }),
                        type: Scilearn.TIMEOUT_MODAL, message: "training_schedule"}));
                }
                break;
            case "1":
                if (this.config.allowBrowserVersion) {
                    const delta: IUserModelDelta = {
                        justChangedStep: false, justCompletedQuiz: false, justCompletedRecording: false,
                        justCompletedSentence: false, justCompletedRequiredRecordings: false,
                        justCompletedSelection: false, justCompletedTAI: true,
                        canPlayback: false, initializeState: false, currentStep: BookSessionType.PREVIEW
                    };
                    this.eventBus.next(new UserModelChangedEvent(delta));
                    this.eventBus.next(new TaiEvent(TAI_STATUS.end_tai, ""));
                }
                break;
            case "a":
                if (this.config.allowBrowserVersion) {
                    this.log.log("A pressed, toggle audio support");
                    this.studentConfig.isAudioAllowed = !this.studentConfig.isAudioAllowed;
                }
                break;
            case "c":
                this.log.log("C pressed, generate correct");
                this.eventBus.next(new DebugEvent(DebugCommand.CORRECT_INPUT));
                break;
            case "d":
                this.log.log("D pressed, launch record debug window");
                this.eventBus.next(new DebugEvent(DebugCommand.DEBUG_DIALOG));
                break;
            case "g":
                if (this.config.allowBrowserVersion) {
                    this.log.log("G pressed, toggle glossary language support");
                    this.studentConfig.glossaryIsSpanishEnabled = !this.studentConfig.glossaryIsSpanishEnabled;
                }
                break;
            case "i":
                this.log.log("I pressed, generate incorrect");
                this.eventBus.next(new DebugEvent(DebugCommand.INCORRECT_INPUT));
                break;
            case "r":
                this.log.log("R pressed, activate runtime tests");
                this.eventBus.next(new RuntimeTestEvent(RUNTIMETEST_STATUS.manual));
                break;
            case "s":
                this.log.log("S pressed, skip one sentence");
                this.eventBus.next(new DebugEvent(DebugCommand.SKIP_SENTENCE));
                break;
            case "t":
                this.log.log("T pressed, skip one text");
                this.eventBus.next(new DebugEvent(DebugCommand.SKIP_TEXT));
                break;
            case "l":
                this.log.log("L pressed, display log");
                if(event.target instanceof HTMLInputElement === false){
                    this.eventBus.next(new DebugEvent(DebugCommand.DEBUG_LOG));
                }
                break;
            default:
        }
    }


}
